// src/IdleHandler.js
import { useEffect, useRef, useCallback } from 'react';
import { getToastAPI } from './Components/ui/Toast';
import api from './api/api';

const hasActiveSession = () => {
  // El token real vive en una cookie HttpOnly; usamos un indicador local ligero
  return Boolean(localStorage.getItem('currentUser'));
};

export default function IdleHandler({ children }) {
  const timeoutId = useRef(null);

  // Logout y redirección
  const logout = useCallback(async () => {
    try {
      await api.post('/logout');
    } catch {
      // Ignorar errores de red
    }
    localStorage.clear();
    getToastAPI().show("Has sido desconectado por inactividad.", { type: 'warning', duration: 4000 });
    setTimeout(() => {
      window.location.href = "/login";
    }, 2200);
  }, []);

  // Resetea el temporizador de inactividad
  const resetTimer = useCallback(() => {
    if (!hasActiveSession()) return;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    // 5 minutos = 5 * 60 * 1000 ms
    timeoutId.current = setTimeout(logout, 5 * 60 * 1000);
  }, [logout]);

  useEffect(() => {
    // Solo activar el control de inactividad si hay una sesión iniciada
    if (!hasActiveSession()) return;

    const events = ["click", "mousemove", "keydown", "scroll"];

    // Cada vez que ocurra uno de estos eventos, resetea el timer
    events.forEach(evt => window.addEventListener(evt, resetTimer));

    // Iniciar el primer timer al montar
    resetTimer();

    return () => {
      // Limpieza: quitar listeners y clearTimeout
      events.forEach(evt => window.removeEventListener(evt, resetTimer));
      clearTimeout(timeoutId.current);
    };
  }, [resetTimer]);

  return children;
}
